import { ColTypeDef } from "@ag-grid-community/core";
import { MaybernTableAmountCellEditor } from "shared/components/table/maybern/MaybernTableAmountCellEditor";
import { MaybernTableAmountCellEditorRenderer } from "shared/components/table/maybern/MaybernTableAmountCellEditorRenderer";
import { MaybernTableCellRenderer } from "shared/components/table/maybern/MaybernTableCellRenderer";
import {
  MaybernTableDropdownCellEditor,
  MaybernTableDropdownCellEditorParams,
} from "shared/components/table/maybern/MaybernTableDropdownCellEditor";
import { MaybernTableDropdownCellEditorRenderer } from "shared/components/table/maybern/MaybernTableDropdownCellEditorRenderer";
import { MaybernTableDropdownCellRenderer } from "shared/components/table/maybern/MaybernTableDropdownCellRenderer";
import {
  MaybernTableTextCellEditor,
  MaybernTableTextCellEditorRenderer,
} from "shared/components/table/maybern/MaybernTableTextCellEditor";
import {
  maybernTableDecimalSumAggFunc,
  maybernTableMergeHeaderClass,
} from "shared/components/table/maybern/MaybernTableUtils";
import { tryParseDecimal } from "shared/utils/DecimalUtils";
import { formatMoneyWithoutCurrencySymbol } from "shared/utils/MoneyUtils";
import { removeNonNumericCharacters } from "shared/utils/StringUtils";

export const MaybernTableColumnTypes: {
  [key: string]: ColTypeDef;
} = {
  dropdown: {
    cellRenderer: MaybernTableDropdownCellRenderer,
    cellClassRules: {
      "mb-cell-dropdown": () => true,
    },
  },
  dropdownEditable: {
    cellRenderer: MaybernTableDropdownCellEditorRenderer,
    cellEditor: MaybernTableDropdownCellEditor,
    editable: true,
    cellClassRules: {
      "mb-cell-dropdown": () => true,
    },
    valueFormatter: (params) => {
      const dropdownProps = params.colDef
        .cellEditorParams as MaybernTableDropdownCellEditorParams;
      return (
        dropdownProps.options.find((it) => it.value === params.value)?.label ??
        params.value
      );
    },
    valueParser: (params) => {
      const dropdownProps = params.colDef
        .cellEditorParams as MaybernTableDropdownCellEditorParams;
      return (
        dropdownProps.options.find(
          (it) =>
            it.label?.toLowerCase() ===
            (params.newValue as string | null)?.toLowerCase(),
        )?.value ?? ""
      );
    },
  },
  moneyEditable: {
    cellRenderer: MaybernTableAmountCellEditorRenderer,
    cellEditor: MaybernTableAmountCellEditor,
    headerClass: "mb-header-value-type-money",
    cellClassRules: {
      "mb-cell-value-type-money": () => true,
    },
    initialWidth: 200,
    cellDataType: "money",
    valueParser: (params) =>
      tryParseDecimal(
        removeNonNumericCharacters(params.newValue),
      )?.toString() ?? "",
    valueFormatter: (params) =>
      params.value
        ? formatMoneyWithoutCurrencySymbol(params.value, undefined, "")
        : "",
  },
  money: {
    headerClass: maybernTableMergeHeaderClass("mb-header-value-type-money"),
    cellClassRules: {
      "mb-cell-value-type-money": () => true,
    },
    initialWidth: 200,
    cellDataType: "money",
    aggFunc: maybernTableDecimalSumAggFunc,
    valueFormatter: (params) => {
      if (!params.data) {
        const aggData: Record<string, string> | undefined =
          params.node?.aggData;
        if (aggData && params.colDef.field) {
          return aggData[params.colDef.field];
        }
        return "";
      }
      return formatMoneyWithoutCurrencySymbol(params.value, undefined, "");
    },
  },
  moneyInput: {
    headerClass: maybernTableMergeHeaderClass("mb-header-value-type-money"),
    cellRenderer: MaybernTableCellRenderer,
  },
  textEditable: {
    cellRenderer: MaybernTableTextCellEditorRenderer,
    cellEditor: MaybernTableTextCellEditor,
    initialWidth: 200,
  },
};
